import type { IBarteTaxes, IBarteTaxesEarlyCredit } from "@payfac/types";

export const extractAvailableDelays = (taxes: IBarteTaxes): number[] =>
  Object.entries(taxes)
    .filter(([key]) => key.startsWith("earlyCreditCardConfigData_D"))
    .map(([, value]) => (value as IBarteTaxesEarlyCredit).delayForRedeem)
    .sort((a, b) => a - b);
